export default {
	name: 'videoSection',
	title: 'Video Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'videoUrl',
			title: 'Video URL',
			description: 'YouTube or Vimeo URL',
			type: 'url',
		},
		{
			name: 'videoThumbnail',
			title: 'Video Thumbnail',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
	],
};
